const isDev = process.env.ENV !== 'production'

export default ({ app, store, route }) => {
  const fullPath = route.fullPath.replace(/\/(pt|en)/, '')
  const path = fullPath !== '' ? fullPath.split('?')[0] : '/'
  const locale = route.fullPath.split('/')[1]

  return app.$axios
    .$get('/metas/resolve', {
      baseURL: process.env.API_V2_BASE_URL,
      params: { route: path, lang: locale }
    })
    .then((meta) => {
      // APIv2 returns camelCase and no robots field; keep the shape the
      // templates and the store already read.
      const response = {
        ...meta,
        meta_description: meta.metaDescription,
        meta_keywords: meta.metaKeywords,
        head_title: meta.headTitle,
        h1_text: meta.h1Text,
        h2_text: meta.h2Text,
        robots: meta.robots || 'index,follow'
      }

      // eslint-disable-next-line no-unused-vars
      const itemsToReplace = [
        {
          hid: 'description',
          name: 'description',
          content: response.meta_description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: response.meta_keywords
        },
        {
          hid: 'robots',
          name: 'robots',
          content: isDev ? 'noindex,nofollow' : response.robots
        }
      ]

      itemsToReplace.forEach((item) => {
        const metaIndex = app.head.meta.findIndex(
          (meta) => meta.hid === item.hid
        )

        if (metaIndex === -1) {
          app.head.meta.push(item)
          return
        }

        app.head.meta[metaIndex] = item
      })

      app.head.title = response.head_title
      store.commit('SET_META', response)
    })
}
